<template>
  <div>
    <v-container class="rs-controls">
      <v-row>
        <v-col cols="8">
          <v-row dense>
            <v-col cols="3" v-for="(button, index) in buttons" :key="`button-${index}`">
              <SensorButton
                :ref="`button-${index}`"
                v-model="button.value"
                :conversion="button.conversion"
                :name="button.name"
                :initialValue="button.initialValue"
                @input="onSensorInput(button, button.platformIndex == null ? index : button.platformIndex, $event)"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
/*
  js data ---> sendUartData() ---> VBusChannel ---> emit(uartDidTransmit)
*/
import { Bridge } from '@/bridges/Bridge.js';
import SensorButton from '@/components/SensorButton';
import state from '@/state';

const Connection = require('resol-vbus/src/connection');
const Packet = require('resol-vbus/src/packet');

class ZaBridge extends Bridge {
  constructor(options) {
    super();
    this.vbusAddress = 0x111D;
    this.buttons = options.buttons;
    this.connection = new Connection();
    this.connection.on('packet', this.handlePacket.bind(this));
  }

  sendUartData(index, rxBuffer) {
    if (index === 0) {
      this.connection.write(rxBuffer);
    }
  }

  handlePacket(/*packet*/) {
  }
}

export default {
  props: [
    'initialValue'
  ],

  components: {
    SensorButton,
  },

  data: () => ({
    bridge: null,
    intervalId: 0,

    buttons: [
      { conversion: 'resistorPt1000Temperature', value: null, initialValue: 20.0, name: 'S1', },
    ],

    uarts: [
      { name: 'UART0', kind: 'VBus', label: 'GP' },
    ],
  }),

  methods: {
    async prepareDevice() {
      this.bridge = new ZaBridge({
        vbusAddress: this.vbusAddress,
        buttons: this.buttons,
        outputs: this.outputs,
      });
      this.intervalId = state.setInterval(this.intervalHandler.bind(this), 1000);
    },

    startDevice() {},

    restartDevice() {},

    onSensorInput(/*button, index, value*/) {},

    intervalHandler() {
      const value = +(this.$refs['button-0'][0].userFriendlyValue * 10).toFixed(1);

      const txFrameData = Buffer.alloc(8);
      txFrameData.writeUInt8(1, 0); // BlockType Number of payload frames belonging to this sectio
      txFrameData.writeUInt8(1, 1); // BlockType Type Temperature
      txFrameData.writeUInt8(0, 2); // BlockType reserve
      txFrameData.writeUInt8(0, 3); // BlockType reserve
      txFrameData.writeInt16LE(value, 4); // Temperature I16
      txFrameData.writeUInt8(0, 6); // unused
      txFrameData.writeUInt8(0, 7); // unused

      const txPacket = new Packet({
        destinationAddress: 0x0015,
        sourceAddress: this.vbusAddress,
        command: 0x0100,
        frameCount: 2,
        frameData: txFrameData,
      });
      const txBuffer = txPacket.toLiveBuffer();
      for (let i = 0; i < txBuffer.length; i += 1) {
        this.bridge.emit('uartDidTransmit', 0, txBuffer[i]);
      }
    },
  },
};
</script>

<style>

</style>
